import { useMemo, useState } from 'react';

const API = process.env.REACT_APP_API_URL || '';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function isValidEmail(s) {
  const t = (s || '').trim();
  return t.length > 0 && EMAIL_RE.test(t);
}

export default function BetaTestaajaksiPage() {
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const canSubmit = useMemo(() => {
    const r = (reason || '').trim();
    return isValidEmail(email) && r.length >= 10 && r.length <= 4000;
  }, [email, reason]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    setSubmitting(true);
    setSubmitError('');
    const em = (email || '').trim();
    const r = (reason || '').trim();

    fetch(`${API}/api/beta-tester-request`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: em, reason: r }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSuccess(true);
          setEmail('');
          setReason('');
        } else {
          setSubmitError(data.message || 'Lähetys epäonnistui.');
        }
      })
      .catch(() => setSubmitError('Yhteysvirhe. Yritä uudelleen.'))
      .finally(() => setSubmitting(false));
  };

  if (success) {
    return (
      <div className="App-block">
        <div className="beta-tester-content">
          <p>
            <span className="Pulina-highlight">Pulina</span> on uudenlainen tapa esittää osaamistasi, verkostoitua ja
            kaverustua muiden suomalaisten kanssa.
          </p>
          <p>
            Liity mukaan kokemaan, miltä tuntuu jutella rennosti ilman somepaineita – vain sinä ja muut pulisijat.
          </p>
          <p className="Beta-tester-thanks">Kiitos! Ilmoituksesi on vastaanotettu. Palaamme asiaan, jos jatkamme yhteyttä.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App-block">
      <div className="beta-tester-content">
        <p>
          <span className="Pulina-highlight">Pulina</span> on uudenlainen tapa esittää osaamistasi, verkostoitua ja
          kaverustua muiden suomalaisten kanssa.
        </p>
        <p>
          Liity mukaan kokemaan, miltä tuntuu jutella rennosti ilman somepaineita – vain sinä ja muut pulisijat.
        </p>
        <br />
        <ul className="Beta-tester-list">
          <li>
            <strong>
              Beta-testaajilla on ilmainen jäsenyys, eli he voivat käyttää kaikkia Pulinaan sisältyviä ominaisuuksia
              ilmaiseksi.
            </strong>
          </li>
          <li>
            <strong>Beta-testaajan jäsenyys jatkuu niin kauan, kunnes BETA-vaihe päättyy.</strong>
          </li>
          <li>
            <strong>
              Kaikilla Beta-testaajilla on ikuinen <a href="/beta-testaajaksi/tarjous">Early worm -tarjouksen</a>{' '}
              lunastusoikeus.
            </strong>
          </li>
        </ul>
        <form className="Register-form Beta-tester-form" onSubmit={handleSubmit}>
          <label htmlFor="beta-email">
            Sähköposti
            <input
              id="beta-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="sähköposti@esimerkki.fi"
              autoComplete="email"
              disabled={submitting}
            />
          </label>
          <label htmlFor="beta-reason">
            Miksi?
            <textarea
              id="beta-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={5}
              placeholder="Kerro, miksi olet kiinnostunut."
              disabled={submitting}
            />
          </label>
          {submitError ? (
            <p className="Beta-tester-submitError" role="alert">
              {submitError}
            </p>
          ) : null}
          <button
            type="submit"
            className="Button Beta-tester-submit"
            disabled={submitting || !canSubmit}
            title={submitting || canSubmit ? '' : 'Kaikki kentät täytettävä'}
          >
            {submitting ? 'Lähetetään…' : 'Lähetä'}
          </button>
        </form>
      </div>
    </div>
  );
}
